const arrowDropdownUp = {
    svg: '<svg style="width:1.00rem; height:1.00rem;" viewBox="0 0 16 16"><polygon points="2.5 10.75 8 5.25 13.5 10.75"/></svg>',
};

export { arrowDropdownUp as default };
